(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cntrip-group-tour"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('.cntrip-group-tour[data-peak-ranges]');
  if (!root) return;
  const main = root.querySelector('[data-cgt-main]');
  const price = root.querySelector('[data-cgt-price]');
  const priceLabel = root.querySelector('[data-cgt-price-label]');
  const priceSuffix = root.querySelector('[data-cgt-price-suffix]');
  const priceBreakdown = root.querySelector('[data-cgt-price-breakdown]');
  const variant = root.querySelector('[data-cgt-variant]');
  const form = root.querySelector('form.cgt-form');
  const dateInput = root.querySelector('[data-cgt-date]');
  const roomsInput = root.querySelector('[data-cgt-rooms]');
  const quantityInput = root.querySelector('[data-cgt-quantity]');
  const submit = root.querySelector('[data-cgt-submit]');
  const error = root.querySelector('[data-cgt-error]');
  const tripSummary = root.querySelector('[data-cgt-trip-summary]');
  const tripStart = root.querySelector('[data-cgt-trip-start]');
  const tripEnd = root.querySelector('[data-cgt-trip-end]');
  const tripDates = root.querySelector('[data-cgt-trip-dates]');
  const attractionsWrap = root.querySelector('[data-cgt-attractions-wrap]');
  const attractionsToggle = root.querySelector('[data-cgt-attractions-toggle]');

  root.querySelectorAll('[data-cgt-thumb]').forEach((button) => button.addEventListener('click', () => {
    if (main) { main.src = button.dataset.src; main.alt = button.dataset.alt || ''; }
    root.querySelectorAll('[data-cgt-thumb]').forEach((item) => item.classList.remove('is-active'));
    button.classList.add('is-active');
  }));

  if (attractionsWrap && attractionsToggle) attractionsToggle.addEventListener('click', () => {
    const expanded = attractionsWrap.classList.toggle('is-expanded');
    attractionsToggle.setAttribute('aria-expanded', String(expanded));
    attractionsToggle.textContent = expanded ? 'Show fewer attractions' : 'View all attractions';
  });

  const parseRanges = (value) => (value || '').split(',').map((item) => item.trim()).filter(Boolean).map((item) => {
    const parts = item.split('..').map((part) => part.trim());
    return { start: parts[0], end: parts[1] || parts[0] };
  });

  const overlapsRanges = (start, end, ranges) => ranges.some((range) => start <= range.end && end >= range.start);
  const toISODate = (value) => `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
  const peakRanges = parseRanges(root.dataset.peakRanges);
  const schoolRanges = parseRanges(root.dataset.schoolRanges);

  const formatCurrency = (value) => {
    const currencyCode = root.dataset.currency || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: currencyCode, currencyDisplay: 'symbol'
    }).format(value);
  };

  let bookingState = null;

  const syncVariant = () => {
    const selectedDate = dateInput && dateInput.value;
    let tripEndIso = selectedDate;
    if (selectedDate) {
      const dateParts = selectedDate.split('-').map(Number);
      const startDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 4);
      tripEndIso = toISODate(endDate);
      const formatDate = (value) => value.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
      const dateRange = `${formatDate(startDate)} – ${formatDate(endDate)}`;
      if (tripStart) tripStart.textContent = formatDate(startDate);
      if (tripEnd) tripEnd.textContent = formatDate(endDate);
      if (tripDates) tripDates.value = dateRange;
      if (tripSummary) tripSummary.hidden = false;
    } else {
      if (tripDates) tripDates.value = '';
      if (tripSummary) tripSummary.hidden = true;
    }

    const count = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
    const minRooms = Math.ceil(count / 2);
    const maxRooms = count;

    if (roomsInput) {
      roomsInput.min = String(minRooms);
      roomsInput.max = String(maxRooms);
      const currentRooms = Number(roomsInput.value) || minRooms;
      roomsInput.value = String(Math.min(maxRooms, Math.max(minRooms, currentRooms)));
    }

    let period = 'standard';
    if (selectedDate && overlapsRanges(selectedDate, tripEndIso, peakRanges)) period = 'peak';
    else if (selectedDate && overlapsRanges(selectedDate, tripEndIso, schoolRanges)) period = 'school';

    const options = Array.from(variant.options);
    const twinMatch = options.find((option) => option.dataset.pricingPeriod === period && option.dataset.roomType === 'twin');
    const singleMatch = options.find((option) => option.dataset.pricingPeriod === period && option.dataset.roomType === 'single');

    const roomCount = Math.min(maxRooms, Math.max(minRooms, Number(roomsInput && roomsInput.value) || minRooms));
    const singleCount = (roomCount * 2) - count;
    const twinCount = count - singleCount;

    const valid = Boolean(selectedDate && twinMatch && singleMatch);
    bookingState = { selectedDate, period, count, roomCount, singleCount, twinCount, twinMatch, singleMatch, valid };

    const hasSelection = Boolean(selectedDate && twinMatch);
    const totalPrice = statePriceCalc(bookingState);

    if (priceLabel) priceLabel.textContent = hasSelection ? 'Total' : 'From';
    if (priceSuffix) priceSuffix.textContent = hasSelection ? ' for group' : ' / person';
    if (price) {
      if (hasSelection) price.textContent = formatCurrency(totalPrice);
      else if (twinMatch) price.textContent = twinMatch.dataset.price || '';
    }
    if (priceBreakdown) {
      priceBreakdown.hidden = !hasSelection;
      priceBreakdown.textContent = `${twinCount} traveler(s) twin sharing + ${singleCount} single-room supplement`;
    }
    if (submit) submit.disabled = !valid;
    if (error) { error.hidden = valid; error.textContent = selectedDate ? 'Option not available.' : 'Please choose a departure date.'; }
  };

  const statePriceCalc = (s) => {
    if(!s.twinMatch || !s.singleMatch) return 0;
    return (s.twinCount * parseFloat(s.twinMatch.dataset.priceValue)) + (s.singleCount * parseFloat(s.singleMatch.dataset.priceValue));
  }

  [variant, dateInput, roomsInput, quantityInput].filter(Boolean).forEach((field) => {
    field.addEventListener('change', syncVariant);
    field.addEventListener('input', syncVariant);
  });

  if (form) form.addEventListener('submit', (event) => {
    if (!bookingState || !bookingState.valid) return;
    event.preventDefault();
    if (submit) submit.disabled = true;

    // 构建通过 Permalink 结账的 URL 
    // 逻辑：跳转到 /cart/ID:QTY,ID:QTY 格式，这样只结算本次选择且不含旧购物车
    let cartPath = "";
    if (bookingState.twinCount > 0) cartPath += `${bookingState.twinMatch.value}:${bookingState.twinCount},`;
    if (bookingState.singleCount > 0) cartPath += `${bookingState.singleMatch.value}:${bookingState.singleCount}`;
    cartPath = cartPath.replace(/,$/, "");

    const cartRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const baseUrl = `${cartRoot.endsWith('/') ? cartRoot : cartRoot + '/'}cart/${cartPath}`;

    // 处理表单属性 (转为 Attributes 参数)
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      const propertyMatch = key.match(/^properties\[(.+)\]$/);
      if (propertyMatch) params.append(`attributes[${propertyMatch[1]}]`, value);
    });
    params.append('attributes[Occupancy]', `${bookingState.twinCount} Twin, ${bookingState.singleCount} Single`);

    window.location.href = `${baseUrl}?${params.toString()}`;
  });

  syncVariant();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
